
/**
 * Created by rlopez on 11/28/16.
 */
// ActionDetailsView.js

import {View} from 'backbone';
import template from 'dashboard/connections/details/action-databases.ejs';
import * as gridModels from 'dashboard/connections/action-type/ActionGridModels';
import util from 'util/Util';
import constants from 'Constants';
import sequenceService from 'SequenceService';

import _ from 'lodash';

class ActionDatabases extends View {
    initialize(opts){

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            'change input[name=_tableName]':'changeTableName',
            'change input[name=_distinctResults]':'changeDistinct',
            "click button[name=addSend], button[name=addReturn]"          : "itemNew",
            "click button[name=removeSend], button[name=removeReturn]"    : "itemRemove",
            "click button[name=upSend], button[name=upReturn]"            : "itemUp",
            "click button[name=downSend], button[name=downReturn]"        : "itemDown",
            "click button[name=autoSend], button[name=autoReturn]"        : "autoComplete"
        };
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    changeTableName(){
        return this.actionService.changeTableName.apply(this.actionService, arguments);
    }

    changeDistinct(){
        return this.actionService.changeDistinct.apply(this.actionService, arguments);
    }

    itemNew(){
        return this.actionService.itemNew.apply(this.actionService, arguments);
    }

    itemRemove(){
        return this.actionService.itemRemove.apply(this.actionService, arguments);
    }

    itemDown(){
        return this.actionService.itemDown.apply(this.actionService, arguments);
    }

    itemUp(){
        return this.actionService.itemUp.apply(this.actionService, arguments);
    }

    autoComplete(e){
        return this.actionService.autoComplete(e)
            .then(result => {
                console.log("Received action columns", result);
                
                let currentModel = this.model.get('currentActionDetails');
                const isUpdate = this.model.get('currentActionDetails').Type === constants.CONNECTION_DATABASE_UPDATE;
                const isSend = e.target.name  === 'autoSend';
                let op = isSend ? '0' : '-1';
                // Always reset fields
                let parameters = [];

                result.response.table.column.forEach(col => {
                    parameters.push({
                        _fixedValue: '',
                        _id: sequenceService.nextDomId(),
                        _isFixed: "false",
                        _name: col,
                        _operation: op,
                        _value: col
                    })
                });                

                // Updating model only update action has a special case, we need to find the other parameters in the send array
                // save them in a new array and merge both in the original
                if(isSend){
                    if(isUpdate){
                      const returns = currentModel.ActionXML.Action.Send.Parameter.filter(i => i._operation === '-1');
                      currentModel.ActionXML.Action.Send.Parameter = parameters.concat(returns);
                    }else{
                      currentModel.ActionXML.Action.Send.Parameter = parameters;
                    }
                }
                else {
                    if(isUpdate){
                        const sends = currentModel.ActionXML.Action.Send.Parameter.filter(i => i._operation !== '-1');
                        currentModel.ActionXML.Action.Send.Parameter = sends.concat(parameters);
                    }else{
                        currentModel.ActionXML.Action.Receive.Parameter = parameters;
                    }
                }

                // Save and render
                this.model.set('currentActionDetails', currentModel, { silent: true });
                this.model.set('hasChanges', true);
                this.render();
            })
            .catch(err => {
            });
    }



    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderGridsByType(){
        console.log("Re rendering Grid");
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        $('.select,.update,.insert,.delete,.store').addClass('hide');

        // PF-2115 hack. Action details Type confused with connection Type. Convert to first action type.
        if (currentModel.Type.length === 1){
            currentModel.Type += "1";
        }

        switch (currentModel.Type){
            case constants.CONNECTION_DATABASE_SELECT:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_DATABASE_PARAMETER_HEADERS,
                    constants.CONNECTION_SELECT_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DATABASE_PARAMETER_HEADERS,
                    constants.CONNECTION_SELECT_RETURN_CONTAINER,
                );
                $('.select').removeClass('hide');
                break;
            case constants.CONNECTION_DATABASE_UPDATE:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_DATABASE_PARAMETER_HEADERS,
                    constants.CONNECTION_UPDATE_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DATABASE_PARAMETER_HEADERS,
                    constants.CONNECTION_UPDATE_RETURN_CONTAINER,
                );
                $('.update').removeClass('hide');
                break;
            case constants.CONNECTION_DATABASE_INSERT:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DATABASE_PARAMETER_HEADERS,
                    constants.CONNECTION_INSERT_SEND_CONTAINER
                );
                $('.insert').removeClass('hide');
                break;
            case constants.CONNECTION_DATABASE_DELETE:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_DATABASE_PARAMETER_HEADERS,
                    constants.CONNECTION_DELETE_SEND_CONTAINER
                );
                $('.delete').removeClass('hide');
                break;
            case constants.CONNECTION_DATABASE_STORE_PROCEDURE:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DATABASE_STORE_PROCEDURE_PARAMETER_HEADERS,
                    constants.CONNECTION_STORE_PROCEDURE_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DATABASE_STORE_PROCEDURE_PARAMETER_HEADERS,
                    constants.CONNECTION_STORE_PROCEDURE_RETURN_CONTAINER,
                );
                $('.store').removeClass('hide');
                break;
        }
        this.resizeGrid();
    }

    renderParametersGrid(colSendModel,colSendNames,colSendContainer,colReturnModel,colReturnNames,colReturnContainer){
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        console.log("Current Action Details",currentModel);
        let sendItemsToRender = [];
        const isUpdate = currentModel.Type === constants.CONNECTION_DATABASE_UPDATE;
        // If the type is an update, all the parameters are in the Send array distinguished by their operations
        // -1 for returning parameters, !== -1 for sending parameters, Wee need to separate send parameters into two arrays
        // play with them and render them in their correct grid. 
        if(isUpdate){
            if(currentModel.ActionXML.Action.Send.Parameter instanceof Array){
                sendItemsToRender = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation !== '-1');
            }else{
                sendItemsToRender = [currentModel.ActionXML.Action.Send.Parameter];
            }
         }else{
            sendItemsToRender = currentModel.ActionXML.Action.Send.Parameter instanceof Array
             ? currentModel.ActionXML.Action.Send.Parameter
             : [currentModel.ActionXML.Action.Send.Parameter];
         }

        let returnItemsToRender = [];
        if(isUpdate){
           if(currentModel.ActionXML.Action.Send.Parameter instanceof Array){
             returnItemsToRender = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation === '-1');
           }else{
             returnItemsToRender = [currentModel.ActionXML.Action.Send.Parameter];
           }
        }else{
           returnItemsToRender = currentModel.ActionXML.Action.Receive.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Receive.Parameter
            : [currentModel.ActionXML.Action.Receive.Parameter];
        }


        let gridSendObject = util.getGridObject(this,{
            colModel:colSendModel,
            colNames:colSendNames,
            autowidth:true,
            height: 300,
            scrollOffset:0,
            ondblClickRow:this.ondblClickRowSend
        });
        let gridReturnObject = util.getGridObject(this,{
            colModel:colReturnModel,
            colNames:colReturnNames,
            autowidth:true,
            height: 300,
            scrollOffset:0,
            ondblClickRow:this.ondblClickRowReceive
        });
        $(colSendContainer).jqGrid(gridSendObject);
        $(colReturnContainer).jqGrid(gridReturnObject);
        _.forEach(sendItemsToRender, (field, index) => {
            self.fillNewRow(colSendContainer,index, field['_fixedValue'],field['_id'] ,field['_isFixed'],
                field['_name'],field['_operation'] ,field['_value'])
        });
        _.forEach(returnItemsToRender, (field, index) => {
            self.fillNewRow(colReturnContainer,index, field['_fixedValue'],field['_id'] ,field['_isFixed'],
                field['_name'],field['_operation'] ,field['_value'])
        });
    }

    ondblClickRowSend (rowid, iRow,iCol){
        let containerToWork='#' + this.id;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    ondblClickRowReceive (rowid, iRow,iCol){
        let containerToWork= '#' + this.id;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol){
        let currentGrid=this.model.get('currentGridSelector'),
            currentModel=this.model.get('currentActionDetails'),
            isSend = currentGrid.indexOf('Send') > 0;
        console.log('Current Grid',currentGrid);
        console.log("Editing",rowId);
        console.log("Editing",cellName);
        console.log("Editing",value);
        if(isSend){
            if(cellName === '_value'
                && currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']
                && currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew'] !== 'false'){

                currentModel.ActionXML.Action.Send.Parameter[rowId]['_name'] = value;
                currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']=false;
            }
            else if(cellName === '_name'){
                currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']=false;
            }
            currentModel.ActionXML.Action.Send.Parameter[rowId][cellName] = value;
        }
        else{
            if (currentModel.Type === constants.CONNECTION_DATABASE_UPDATE){
                let sendValueItems = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation === '-1');
                if (sendValueItems){
                    if(cellName === '_value' &&
                        sendValueItems[rowId]['_isNew'] &&
                        sendValueItems[rowId]['_isNew'] !== 'false'){

                        sendValueItems[rowId]['_name'] = value;
                        sendValueItems[rowId]['_isNew']=false;
                    }
                    sendValueItems[rowId][cellName] = value;
                }
            }else{
                if(cellName === '_value' &&
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew'] &&
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew'] !== 'false'){

                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_name'] = value;
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew']=false;
                }
                currentModel.ActionXML.Action.Receive.Parameter[rowId][cellName] = value;
            }
        }
        this.model.set('currentActionDetails',currentModel,{silent:true});
        this.model.set('hasChanges',true,{silent:true});
        this.model.trigger('change');
        console.log("Model After Save Cell",currentModel);
    }

    onSelectRow(){}

    onCellSelect(){}

    fillNewRow(grid,index, _fixedValue,_id,_isFixed,_name, _operation, _value) {
        $(grid).addRowData(index, {
            '_fixedValue':_fixedValue,
            '_id': _id,
            '_isFixed':_isFixed,
            '_name':_name,
            '_operation':_operation,
            '_value':_value
        });
    }

    setRow(rowId, e){
        console.log('before select row',e);
        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
        this.model.set('currentGridSelector',`#${e.currentTarget.id}`,{silent:true});
    }//

    afterEditCell(rowId, cellName, value, iRow, iCol){
        let self=this;
        $("#"+iRow+"_"+cellName).bind('blur',function(){
            $(self.model.get('currentGridSelector')).saveCell(iRow,iCol);
        });
    }

    render(){
        console.log("Rendering Grids");
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.renderGridsByType();

        this.delegateEvents();
        return this;
    }

    remove(){
        $(window).unbind('resize');
        super.remove();
    }
}

export default ActionDatabases;